// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: AddFacilityPage.js
// Description: This file is responsible for Add facilities
//
// ************************************************************************************************************************************************************
import React, { useState, useEffect } from "react";
import CountryCode from "../../data/CountryCode.json";
import "../../../../App.css";
import { makeStyles } from "@material-ui/styles";
/* eslint-disable react-hooks/exhaustive-deps */

import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addFacility,
  editFacility,
  getFacilityDetailsById,
} from "../_redux/facilityCrud";
import stateList from "../../data/stateList.json";
import timeZoneList from "../../data/timeZoneList.json";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
} from "@material-ui/core";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import { Slide } from "@material-ui/core";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#158380"
    }
  },
  alertMsg: {
    color: "red"
  },
  MuiBackdrop: {
    backgroundColor: "rgba(0,0,0,0.6)"
  }
}));
let initialValues = {
  hospitalName: "",
  physicalAddress: "",
  city: "",
  state: "",
  zip: "",
  timeZone: "",
  facilityId: "",
  facilityContactName: "",
  email: "",
  phone: "",
  mcaRepName: ""
};
export default function AddFacilityPage(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [responseStatus, setResponse] = useState(false);
  const [errorMsg, setMessage] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [uiLoading, setUiLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("+1");
  const [facilities, setFacilities] = useState(null);
  const FacilitySchema = Yup.object().shape({
    hospitalName: Yup.string()
      .trim()
      .required("Hospital Name is required"),
    physicalAddress: Yup.string()
      .trim()
      .required("Physical Address is required"),
    city: Yup.string()
      .trim()
      .required("City is required"),
    state: Yup.string().required("State is required"),
    zip: Yup.number()
      .lessThan(100000, "5 digits allowed")
      .moreThan(9999, "5 digits required")
      .typeError("Numbers are allowed")

      .required("Only Numbers are allowed"),
    timeZone: Yup.string().required("Time Zone is required"),
    facilityId: Yup.string()
      .trim()
      .required("Facility Id is required"),
    facilityContactName: Yup.string()
      .trim()
      .required("Facility Contact Name is required"),
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .trim()
      .required("Email is required"),
    phone: Yup.number()
      .moreThan(999999999, "10 digits required")
      .typeError("Numbers are allowed")
      .required("Phone Number is required"),
    mcaRepName: Yup.string().required("MCA REP Name is required")
  });
  const enableLoading = () => {
    setLoading(true);
  };
  const disableLoading = () => {
    setLoading(false);
  };
  const disableMessage = () => {
    setResponse(false);
  };
  const enableMessage = () => {
    setResponse(true);
  };

  function handleChangeCountryCode(event) {
    let value = event.target.value;
    setCountryCode(value);
  }
  useEffect(() => {
    checkAddOrEdit();
  }, [props.is_edit]);

  const checkAddOrEdit = () => {
    if (props.is_edit === "true") {
      setUiLoading(true);
      disableMessage();
      setCountryCode("");
      getFacilityDetailsById(props.edit_id).then((res) => {
        setUiLoading(false);
        if (res.data.status) {
          let data = res.data.data[0];
          formik.setFieldValue("timeZone", data.timezone);
          formik.setFieldValue("hospitalName", data.name);
          formik.setFieldValue("physicalAddress", data.physical_address);
          formik.setFieldValue("city", data.city);
          formik.setFieldValue("state", data.state);
          formik.setFieldValue("zip", data.zip);
          formik.setFieldValue("facilityId", data.facility_id);
          formik.setFieldValue("facilityContactName", data.contact_name);
          formik.setFieldValue("email", data.contact_email);
          formik.setFieldValue("phone", String(data.contact_phone));
          formik.setFieldValue("mcaRepName", data.mca_rep_name);
          setFacilities(data);
          setTimeZone(data.timeZone);
          if (data.country_code !== "" && data.country_code !== null) {
            setCountryCode(data.country_code);
          } else {
            setCountryCode("+1");
          }
        }
        else {
          enableMessage();
          setMessage(res.data.message);
        }
      })
      .catch((error) => {
        disableLoading();
        enableMessage();
        if (error.response) {
          if (error.response.status !== 404 && error) {
            setMessage(error.response.data.message);
          } else {
            props.history.push("error/error-v1");
          }
        } else {
          setMessage(error.message);
        }
      });
    } else {
      setUiLoading(false);
    }
  };
  const handleChangeState = () => (event) => {
    setSelectedState(event.target.value);
  };
  const handleChangeTimeZone = () => (event) => {
    setTimeZone(event.target.value);
  };
  const cancel = (opt) => {
    formik.resetForm();
    setResponse(false);
    props.onHide(opt);
    setCountryCode("+1");
    initialValues.hospitalName = "";
    initialValues.physicalAddress = "";
    initialValues.city = "";
    initialValues.state = "";
    initialValues.zip = "";
    initialValues.timeZone = "";
    initialValues.facilityId = "";
    initialValues.facilityContactName = "";
    initialValues.email = "";
    initialValues.phone = "";
    initialValues.mcaRepName = "";
  };

  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  };
  const onlyCharacter = (e1) => {
    e1.target.value = e1.target.value.replace(/[^A-Za-z\s]/g, "");
  };


  const formik = useFormik({
    initialValues,
    validationSchema: FacilitySchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      disableMessage();
      setResponse(false);
      if (props.is_edit === "true") {
        let id = facilities.id;
        editFacility(values, countryCode, id)
          .then((res) => {
            setSubmitting(false);
            disableLoading();
            if (res.data.status) {
              cancel("add");
              formik.resetForm();
            } else {
              enableMessage();
              setMessage(res.data.message);
            }
          })
          .catch((error) => {
            disableLoading();
            setSubmitting(false);
            enableMessage();
            if (error.response) {
              if (error.response.status !== 404 && error) {
                const a = error.response.data.message;
                setMessage(a);
              } else {
                props.history.push("error/error-v1");
              }
            } else {
              setMessage(error.message);
            }
          });
      } else {
        addFacility(values, countryCode)
          .then((res) => {
            setSubmitting(false);
            disableLoading();
            if (res.data.status) {
              cancel("add");
              formik.resetForm();
            } else {
              enableMessage();
              setMessage(res.data.message);
            }
          })
          .catch((error) => {
            disableLoading();
            setSubmitting(false);
            enableMessage();
            if (error.response) {
              if (error.response.status !== 404 && error) {
                setMessage(error.response.data.message);
              } else {
                props.history.push("error/error-v1");
              }
            } else {
              setMessage(error.message);
            }
          });
      }
    }
  });

  const [fullWidth] = React.useState(true);
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <div>
      <Dialog
        // {...props}                       //uncomment if required
        PaperProps={{}}
        className={classes.MuiBackdrop + " popupstyle"}
        disableBackdropClick
        TransitionComponent={Transition}
        keepMounted
        fullWidth={fullWidth}
        maxWidth="md"
        open={props.show}
        onClose={cancel}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <div className="dialogTitle">
          <DialogTitle id="scroll-dialog-title">
            {props.is_edit === "true" ? (
              <span className="dialogtitle">Edit Facility</span>
            ) : (
              <span className="dialogtitle">Add Facility</span>
            )}
          </DialogTitle>
          <IconButton onClick={cancel} aria-label="close" className="closebtn">
            <CloseIcon />
            close
          </IconButton>
        </div>

        <DialogContent>
          <DialogContentText
            component="div"
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            {!uiLoading ? (
              <form onSubmit={formik.handleSubmit} id="myForm">
                <div className="row">
                  <div className="col-md-12">
                    <TextField
                      className={classes.root}
                      name="hospitalName"
                      id="hospitalName"
                      margin="normal"
                      label="Hospital Name"
                      type="text"
                      fullWidth
                      required
                      onInput={(e1) => onlyCharacter(e1)}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 500
                      }}
                      {...formik.getFieldProps("hospitalName")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("hospitalName", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.hospitalName &&
                    formik.errors.hospitalName ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.hospitalName}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-12">
                    <TextField
                      className={
                        formik.touched.physicalAddress &&
                        formik.errors.physicalAddress
                          ? "custom-input-error"
                          : ""
                      }
                      name="physicalAddress"
                      id="physicalAddress"
                      margin="normal"
                      label="Address"
                      placeholder="Hospital Address"
                      type="text"
                      fullWidth
                      required
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 255
                      }}
                      {...formik.getFieldProps("physicalAddress")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("physicalAddress", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.physicalAddress &&
                    formik.errors.physicalAddress ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.physicalAddress}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      id="city"
                      className={classes.root}
                      name="city"
                      margin="normal"
                      label="City"
                      type="text"
                      required
                      placeholder="( eg: Mumbai )"
                      fullWidth
                      variant="outlined"
                      size="small"
                      onInput={(e1) => onlyCharacter(e1)}
                      color="secondary"
                      inputProps={{
                        maxLength: 50
                      }}
                      {...formik.getFieldProps("city")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("city", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.city && formik.errors.city ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.city}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div
                    className="col-md-4"
                    style={{
                      paddingTop: "15px"
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      className={classes.root}
                    >
                      <InputLabel
                        id="demo-simple-select-standard-label"
                        required
                      >
                        State
                      </InputLabel>
                      <Select
                        name="state"
                        id="state"
                        size="small"
                        variant="outlined"
                        label="State"
                        placeholder="State"
                        inputProps={{
                          maxLength: 12
                        }}
                        value={selectedState}
                        onChange={handleChangeState("state")}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                          },
                          getContentAnchorEl: null
                        }}
                        SelectProps={{
                          native: true,
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        {...formik.getFieldProps("state")}
                      >
                        {stateList.map((state, index) => {
                          return (
                            <MenuItem key={index} value={state.name}>
                              {state.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <br />

                    {formik.touched.state && formik.errors.state ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.state}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-4">
                    <TextField
                      id="zip"
                      className={classes.root}
                      name="zip"
                      margin="normal"
                      label="Zip Code"
                      required
                      type="text"
                      fullWidth
                      onInput={(e) => onlyNumbers(e)}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 5
                      }}
                      {...formik.getFieldProps("zip")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("zip", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.zip && formik.errors.zip ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{formik.errors.zip}</div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-md-6"
                    style={{
                      paddingTop: "15px"
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      className={classes.root}
                    >
                      <InputLabel
                        id="demo-simple-select-standard-label"
                        required
                      >
                        TimeZone
                      </InputLabel>
                      <Select
                        name="timeZone"
                        id="timeZone"
                        variant="outlined"
                        placeholder="TimeZone"
                        label="Time Zone"
                        inputProps={{
                          maxLength: 12
                        }}
                        value={timeZone}
                        onChange={handleChangeTimeZone("time")}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                          },
                          getContentAnchorEl: null
                        }}
                        SelectProps={{
                          native: true,
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        {...formik.getFieldProps("timeZone")}
                      >
                        {timeZoneList.map((time, index) => {
                          return (
                            <MenuItem key={index} value={time.name}>
                              {time.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <br />
                    {formik.touched.timeZone && formik.errors.timeZone ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.timeZone}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <TextField
                      id="facilityId"
                      className={classes.root}
                      name="facilityId"
                      margin="normal"
                      label="Facility Id"
                      required
                      type="text"
                      fullWidth
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 50
                      }}
                      {...formik.getFieldProps("facilityId")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("facilityId", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              <HighlightOffRoundedIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.facilityId && formik.errors.facilityId ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.facilityId}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <TextField
                      id="facilityContactName"
                      className={classes.root}
                      name="facilityContactName"
                      margin="normal"
                      label="Facility Contact Name"
                      type="text"
                      fullWidth
                      required
                      onInput={(e1) => onlyCharacter(e1)}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 50
                      }}
                      {...formik.getFieldProps("facilityContactName")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("facilityContactName", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              <HighlightOffRoundedIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.facilityContactName &&
                    formik.errors.facilityContactName ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.facilityContactName}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <TextField
                      id="mcaRepName"
                      className={classes.root}
                      name="mcaRepName"
                      margin="normal"
                      label="MCA REP Name"
                      type="text"
                      required
                      fullWidth
                      onInput={(e1) => onlyCharacter(e1)}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 50
                      }}
                      {...formik.getFieldProps("mcaRepName")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("mcaRepName", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.mcaRepName && formik.errors.mcaRepName ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.mcaRepName}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <TextField
                      id="email"
                      className={classes.root}
                      name="email"
                      margin="normal"
                      label="Email"
                      type="email"
                      required
                      fullWidth
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 50
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      {...formik.getFieldProps("email")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("email", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.email}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-sm-2 countrycode-select">
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      className={classes.root}
                    >
                      <Select
                        fullWidth
                        color="secondary"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        className={classes.root}
                        onChange={handleChangeCountryCode}
                        value={countryCode}
                        SelectProps={{
                          native: true,
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        required
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                          },
                          getContentAnchorEl: null
                        }}
                      >
                        {CountryCode.map((value, index) => {
                          return (
                            <MenuItem key={index} value={value.dial_code}>
                              {value.code}
                              &nbsp;
                              {value.dial_code}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-4">
                    <TextField
                      id="phone"
                      className={classes.root}
                      name="phone"
                      margin="normal"
                      required
                      label="Phone Number"
                      onInput={(e) => onlyNumbers(e)}
                      placeholder="Phone Number"
                      fullWidth
                      variant="outlined"
                      color="secondary"
                      size="small"
                      inputProps={{
                        maxLength: 10
                      }}
                      {...formik.getFieldProps("phone")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("phone", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              <HighlightOffRoundedIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.phone}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <DialogActions
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "40px 0"
                  }}
                >
                  <div className="col-xs-6" align="center">
                    {responseStatus ? (
                      <div className={`d-flex p-2 ${classes.alertMsg}`}>
                        {errorMsg}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end"
                    }}
                  >
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn shadow-btn "
                      onClick={cancel}
                    >
                      Cancel
                    </button>
                    &nbsp;
                    <button
                      className="saveButton"
                      color="secondary"
                      type="submit"
                    >
                      Save
                      {loading && (
                        <span className="ml-3 spinner spinner-light"></span>
                      )}
                    </button>
                  </div>
                </DialogActions>
              </form>
            ) : (
              <div align="center">               
                {responseStatus ? (
                   <div style={{marginBottom: "30px"}} className={`d-flex p-2 ${classes.alertMsg}`}>
                     {errorMsg}
                   </div>
                 ) : (
                  <span className="ml-3 spinner spinner-dark"></span>
                 )}
              </div>
              
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>

    </div>
  );
}

